(ns global.endor.checkout.ui.style.colors
  (:require [global.endor.checkout.ui.style.base :as base]))

(def text
  {:primary (base/colors :white)
   :secondary (base/colors :black)})

(def background
  {:primary (base/colors :black)
   :secondary (base/colors :white)})

(def background-sub
  {:primary {:5-percent "rgba(0,0,0,0.05)"
             :10-percent "rgba(0,0,0,0.1)"
             :20-percent "rgba(0,0,0,0.2)"
             :50-percent "rgba(0,0,0,0.5)"}
   :secondary {:5-percent "rgba(255,255,255,0.05)"
               :10-percent "rgba(255,255,255,0.1)"
               :20-percent "rgba(255,255,255,0.2)"
               :50-percent "rgba(255,255,255,0.5)"}})

(def button
  {:primary {:bg (base/colors :white)
             :stroke (base/colors :white)
             :text (base/colors :black)
             :icon (base/colors :black)}
   :secondary {:bg "rgba(0, 0, 0, 0.0)"
               :stroke (base/colors :white)
               :text (base/colors :white)
               :icon (base/colors :white)}
   :tertiary {:bg (base/colors :black)
              :stroke (base/colors :black)
              :text (base/colors :white)
              :icon (base/colors :white)}
   :caution {:bg (base/colors :fire-red-2)
             :stroke (base/colors :white)
             :text (base/colors :white)
             :icon (base/colors :white)}})

(def system
  {:information (base/colors :sky-blue-bright)
   :success (base/colors :forest-green-bright)
   :warning (base/colors :fire-red-bright)
   :error (base/colors :fire-red-2)})
